import React from "react";
import CloseIcon from "../../assets/close";
import { ActionIcon } from "rizzui";
import cn from "../../lib/utils/class-name";
import { useLocation } from "react-router";

export default function DrawerHeader({
  onClose,
  status,
  location,
}: {
  onClose: () => void;
  status;
  location?: string;
}) {
  status = status.replace(" ", "_").toLowerCase();
  return (
    <>
      {/*       {location === "leads" && (
        <div
          className={cn(
            "absolute top-[28px] px-[12px] py-[1px] right-[20px] font-switzer font-[400] text-[12px] leading-[22px] border-[1px]",
            status === "booked"
              ? "text-[#38F2A8] bg-[#25A1700F] border-[#25A1700F]"
              : "text-[#E63946] bg-[#E639461A] border-[#E639461A]"
          )}
        >
          {status === "booked"
            ? "Appointment Booked"
            : "Appointment Not Booked"}
        </div>
      )} */}
      <ActionIcon
        variant="text"
        onClick={onClose}
        className={"text-primary-dark p-0"}
        rounded="full"
      >
        <CloseIcon className={"text-primary-dark"} />
      </ActionIcon>
    </>
  );
}
